//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint vue/attribute-hyphenation: 0 */
import { VueEditor, Quill } from 'vue2-editor';
import ImageResize from 'quill-image-resize-module';
import { Audio } from '../../vendor/editor/audio';
import { Video } from '../../vendor/editor/video';

// link format
let Link = Quill.import('formats/link');

class MyLink extends Link {
    static create(href) {
        let node = super.create(href);
        href = this.sanitize(href);
        if (!href.startsWith('http')) {
            href = 'http://' + href;
        }
        node.setAttribute('href', href);

        return node;
    }
}

Quill.register(MyLink);

// clipboard
const Clipboard = Quill.import('modules/clipboard');
const Delta = Quill.import('delta');

class PlainClipboard extends Clipboard {
    onPaste (e) {
        e.preventDefault();
        const range = this.quill.getSelection();
        const text = e.clipboardData.getData('text/plain');
        const delta = new Delta()
            .retain(range.index)
            .delete(range.length)
            .insert(text);
        const index = text.length + range.index;
        const length = 0;
        this.quill.updateContents(delta);
        this.quill.setSelection(index, length);
        this.quill.scrollIntoView();
    }
}

Quill.register('modules/clipboard', PlainClipboard, true);

// audio blot
let BlockEmbed = Quill.import('blots/block/embed');

class AudioBlot extends BlockEmbed {
    static create (value) {
        let node = super.create();
        node.setAttribute('controls', '');
        node.setAttribute('src', value.url);
        return node;
    }

    static value (node) {
        return {
            controls: node.getAttribute('controls'),
            url: node.getAttribute('src')
        };
    }
}

AudioBlot.blotName = 'audio';
AudioBlot.tagName = 'audio';
Quill.register(AudioBlot);

// video blot
class VideoBlot extends BlockEmbed {
    static create (value) {
        let node = super.create();
        node.setAttribute('controls', '');
        node.setAttribute('src', value.url);
        return node;
    }

    static value (node) {
        return {
            controls: node.getAttribute('controls'),
            url: node.getAttribute('src')
        };
    }
}

VideoBlot.blotName = 'video';
VideoBlot.tagName = 'video';
Quill.register(VideoBlot);

export default {
    components: {
        VueEditor
    },

    props: {
        value: {
            required: true,
            type: String
        },
        showImageUpload: {
            type: Boolean,
            default: false
        },
        requestUrl: {
            type: String,
            required: false
        },
        showAudioModule: {
            type: Boolean,
            required: false
        },
        showVideoModule: {
            type: Boolean,
            required: false
        }
    },

    data () {
        return {
            content: this.value,
            name: 'ide-editor__' + this._uid
        };
    },

    computed: {
        editorToolbar () {
            let toolbar = [
                ['bold', 'italic', 'underline'],
                [{'align': ''}, {'align': 'center'}, {'align': 'right'}],
                ['blockquote'],
                ['link'],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{ 'color': [] }, { 'background': [] }]
            ];

            if (this.showImageUpload) {
                toolbar.push(['image']);
            }

            if (this.showAudioModule) {
                toolbar.push(['audio']);
            }

            if (this.showVideoModule) {
                toolbar.push(['video']);
            }

            return toolbar;
        },
        customModules () {
            let modules = [];

            modules.push({
                alias: 'imageResize',
                module: ImageResize
            });

            if (this.showAudioModule) {
                modules.push({
                    alias: 'audio',
                    module: Audio
                });
            }

            if (this.showVideoModule) {
                modules.push({
                    alias: 'video',
                    module: Video
                });
            }

            return modules;
        },
        editorOptions () {
            let options = {
                modules: {
                    imageResize: {
                        modules: [
                            'Resize',
                            'DisplaySize'
                        ]
                    }
                },
                bounds: '#' + this.name
            };

            if (this.showAudioModule) {
                options.modules.audio = {
                    id: this.name,
                    url: this.requestUrl
                };
            }

            if (this.showVideoModule) {
                options.modules.video = {
                    id: this.name,
                    url: this.requestUrl
                };
            }

            return options;
        }
    },

    watch: {
        value () {
            if (typeof this.value !== 'undefined') {
                this.content = this.value;
            }
        },
        content () {
            this.$emit('input', this.content);
        }
    },

    methods: {
        handleImageAdded (file, Editor, cursorLocation, resetUploader) {
            let formData = new FormData();
            formData.append('file', file);

            axios({
                method: 'POST',
                url: this.requestUrl,
                data: formData
            }).then(response => {
                let url = response.data.path;
                Editor.insertEmbed(cursorLocation, 'image', url);
                resetUploader();
            }).catch(error => {
                this.$notify({
                    message: error.message,
                    type: 'error'
                });
            });
        },
        handleImageRemoved (file) {
            axios({
                method: 'DELETE',
                url: this.requestUrl,
                data: {
                    file_path: file
                }
            }).then(() => {}).catch(error => {
                this.$notify({
                    message: error.message,
                    type: 'error'
                });
            });
        }
    }
};
